import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/linehaul-cost')({
  component: AdminLinehaulCostRoute,
});

function AdminLinehaulCostRoute() {
  return <Outlet />;
}
